<template>
  <Breadcrumbs
      title="View Route"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Routes', path: '/routes' },
      { label: 'View Route', path: `/view-route?routeId=${routeId}` },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <viewRouteForm :routeId="routeId"/>
    </div>
  </div>
</template>

<script>

import viewRouteForm from "@/pages/master_data/routes/viewRouteForm.vue";

export default {
  components: {
    viewRouteForm
  },
  computed: {
    routeId() {
      return this.$route.query.routeId;
    }
  }
}
</script>